// src/utils/recentProjects.js
// "Zuletzt verwendete Projekte" pro Mitarbeiter:in fuer den Rechtsklick-
// Schnellmodus im Kalender - rein lokal (localStorage), kein Azure-Roundtrip.
const STORAGE_KEY_PREFIX = "zeiterfassung_recent_projects_";
const MAX_RECENT = 6;

export const getRecentProjects = (employeeUuid) => {
  if (!employeeUuid) return [];
  try {
    const raw = localStorage.getItem(STORAGE_KEY_PREFIX + employeeUuid);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
};

// project: { code, name }
export const addRecentProject = (employeeUuid, project) => {
  if (!employeeUuid || !project?.code) return;
  try {
    const current = getRecentProjects(employeeUuid).filter(
      (p) => p.code !== project.code
    );
    const updated = [
      { code: project.code, name: project.name || project.code },
      ...current,
    ].slice(0, MAX_RECENT);
    localStorage.setItem(
      STORAGE_KEY_PREFIX + employeeUuid,
      JSON.stringify(updated)
    );
  } catch {
    // localStorage voll/deaktiviert - Feature einfach uebersprungen
  }
};
